export class StorageUsage {
	constructor(
		readonly contracted: number,
		readonly used: number,
		readonly usedPercent: number,
	) {}

	get availableGbs() {
		const diff = this.contracted - this.used
		return diff / 1.074e9
	}
}
